<template>
  <v-form v-model="dataIsValid">
    <v-row>
      <!--title-->
      <v-col cols="12" md="5" offset-md="0">
        <div class="mb-3 body-1 font-weight-medium" v-if="!editDisable">
          {{$t('pages.agreementConclusionChangeOwner.inputPassport')}}
        </div>
      </v-col>
      <v-col cols="12" md="4" offset-md="3">
        <div class="address-title">
          <div class="mb-3 body-1 font-weight-medium">
            {{$t('pages.agreementConclusionChangeOwner.regAddress')}}
          </div>
        </div>
      </v-col>
      <!--end of title-->
      <!--2 column form-->
      <!--col 1-->
      <v-col cols="6" md="4" offset-sm="0">
        <!--column inner-->
        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.typeDocument')}}: *</div>
        <v-select
          :items="docs"
          v-model="doc"
          :disabled="editDisable"
          outlined
        ></v-select>

        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.documentSeries')}}: *</div>
        <v-text-field
          outlined
          v-mask="'####'"
          v-model="series"
          :rules="seriesRules"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.documentNumber')}}: *</div>
        <v-text-field
          outlined
          v-model="number"
          v-mask="'######'"
          :rules="numberRules"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.issuedPassport')}}: *</div>
        <v-text-field
          outlined
          v-model="issuer"
          :rules="notEmptyRule"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.dateIssue')}}: *</div>

        <input-date-picker
          v-model="issueDate"
          :disabled="editDisable"
          :rules="notEmptyRule"
        ></input-date-picker>

        <!--end of column inner-->
      </v-col>
      <!--col 2-->
      <v-col cols="6" md="4" offset-sm="0">
        <!--column inner-->

        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.departamentCode')}}: *</div>
        <v-text-field
          outlined
          v-model="unitCode"
          v-mask="'######'"
          :rules="unitCodeRules"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.dateBirth')}}: *</div>
        <input-date-picker
          v-model="birthDate"
          :disabled="editDisable"
          :rules="notEmptyRule"
        ></input-date-picker>

        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.placeBirth')}}: *</div>
        <v-text-field
          outlined
          v-model="birthPlace"
          :rules="notEmptyRule"
          :disabled="editDisable"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">{{$t('pages.agreementConclusionChangeOwner.phone')}}: *</div>
        <v-text-field
          outlined
          v-model="phone"
          :disabled="editDisable"
          v-mask="'+7 (###) ###-##-##'"
          :rules="notEmptyRule.concat(length18)"
        ></v-text-field>
        <div v-if="objectLocateType" class="red--text mb-6 fs-12">
          Заполните поле ИНН или СНИЛС
        </div>

        <div class="mb-3 body-1 font-weight-medium">ИНН:</div>
        <v-text-field
          outlined
          :rules="isInnRequired? length12AndNotEmpty : length12"
          :disabled="editDisable"
          v-mask="'############'"
          v-model="inn"
        ></v-text-field>

        <div class="mb-3 body-1 font-weight-medium">СНИЛС:</div>
        <v-text-field
          outlined
          :rules="isSnilsRequired? length11AndNotEmpty : length11"
          :disabled="editDisable"
          v-mask="'###########'"
          v-model="snils"
        ></v-text-field>

        <!--end of column inner-->
      </v-col>
      <v-col cols="6" md="4" offset-sm="0">
        <!--   <address-form
          addressType="802740000"
          :income="registrationsAddress"
          :address="formData.addresses ? formData.addresses[0] : null"
          @transferData="setRegistrationsAddress"
        ></address-form> -->
        <div class="mb-3 body-1 font-weight-medium">Адрес: *</div>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span class="fs-12 red--text">{{ addressErrorText }}</span>
            <v-combobox
              :disabled="editDisable"
              v-bind="attrs"
              v-on="on"
              v-model="regAddress"
              outlined
              :search-input.sync="searcher"
              :items="res"
              item-text="value"
              :rules="regAddressRules"
            ></v-combobox>
          </template>

          <span v-if="regAddress.length > 0">
            {{ regAddress }}
          </span>
          <span v-else-if="regAddress.value != null">
            {{ regAddress.value }}
          </span>
          <span v-else> {{$t('pages.agreementConclusionChangeOwner.inputAddress')}} </span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mask } from "vue-the-mask";
import InputDatePicker from "../../common/InputDatePickerWithChange";
import AddressForm from "./partial/AddressForm1";
import { mapState } from "vuex";

export default {
  directives: {
    mask,
  },
  props: ["income", "document", "formData"],
  components: {
    InputDatePicker,
    AddressForm,
  },
  data: () => ({
    isEqualRegAddress: false,
    registrationsAddress: null,
    gg: "",
    // DATA
    docs: ["Паспорт"],
    doc: "Паспорт",
    series: "",
    number: "",
    issuer: "",
    issueDate: "",
    unitCode: "",
    birthDate: "",
    birthPlace: "",
    dataIsValid: false,
    inn: "",
    regAddress: "",
    regAddressData: null,
    res: [],
    dataRequestCount: 0,
    searcher: "",
    snils: "",
    phone: "",
    openFirst: true,
    addressErrorText: "",
    objectLocateType: false,
  }),
  computed: {
    ...mapState({
      editDisable: (state) => state.statements.editDisable,
    }),
    isInnRequired() {
      return this.objectLocateType && this.snils.length == 0;
    },
    isSnilsRequired() {
      return this.objectLocateType && this.inn.length == 0;
    },
    errorText()
    {  
      return this.$t('pages.agreementConclusionChangeOwner.correctAddress')
    },
    notEmptyRule(){
      return [(value) => value === 0 || !!value || this.$t('rules.fieldRequire')]
    },
    seriesRules(){
      return [
      (value) => !!value || this.$t('rules.fieldRequire'),
      (value) => value.length === 4 || this.$t('rules.length4'),
      ]
    },
    numberRules(){
      return [
      (value) => !!value || this.$t('rules.fieldRequire'),
      (value) => value.length === 6 || this.$t('rules.length6'),
      ]
    },
    unitCodeRules(){
      return     [
      (value) => !!value || this.$t('rules.fieldRequire'),
      (value) => (value || "").length <= 6 || this.$t('rules.noMoreLength6'),
      ]
    },
    length12AndNotEmpty(){
      return   [
      (value) => !!value || this.$t('rules.fieldRequire'),
      (value) =>
        !value || (value && value.length === 12) || this.$t('rules.correctNumber'),
      ]
    },
    length11AndNotEmpty(){
      return  [
      (value) => !!value || this.$t('rules.fieldRequire'),
      (value) =>
        !value || (value && value.length === 11) || this.$t('rules.correctNumber'),
      ]
    },
    regAddressRules() { return [(v) => !!v || this.$t('rules.inputAddress')]},
    length10(){ 
      return [
      (value) =>
        !value || (value && value.length === 10) || this.$t('rules.correctNumber'),
      ]
    },
    length11(){ 
      return [
      (value) =>
        !value || (value && value.length === 11) || this.$t('rules.correctNumber'),
      ]
    },
    length12(){ 
      return [
      (value) =>
        !value || (value && value.length === 12) || this.$t('rules.correctNumber'),
      ]
    },
    length18(){ 
      return [
      (value) =>
        !value || (value && value.length === 18) || this.$t('rules.correctNumber'),
      ]
    },
  },
  methods: {
    transferData() {
      this.$emit("transfer", {
        series: String(this.series),
        number: String(this.number),
        issuer: this.issuer,
        issueDate: new Date(this.issueDate).getTime(),
        unitCode: this.unitCode,
        birthDate: new Date(this.birthDate).getTime(),
        birthPlace: this.birthPlace,
        inn: String(this.inn),
        snils: String(this.snils),
        phone: this.phone,
        regAddress: this.regAddress,
        registrationsAddress: this.registrationsAddress,
        regAddressData: this.regAddressData,
      });
    },
    changeAddress(val) {
      if (val !== null) {
        var url =
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
        var token = "2f5e0ad569920be225048de64f9448a7b63e3952";
        var query = val;

        var options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Token " + token,
          },
          body: JSON.stringify({ query: query }),
        };

        this.res = [];

        fetch(url, options)
          .then((response) => response.text())
          .then((result) => {
            var resul = JSON.parse(result);

            for (let i = 0; i < resul.suggestions.length; i++) {
              this.res.push(resul.suggestions[i]);
            }
          })
          .catch((error) => console.log("error", error));
      }
    },

    moutedAddress(val) {
      if (val !== null) {
        this.regAddressData = null;
        var url =
          "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
        var token = "2f5e0ad569920be225048de64f9448a7b63e3952";
        var query = val;

        var options = {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Token " + token,
          },
          body: JSON.stringify({ query: query }),
        };

        fetch(url, options)
          .then((response) => response.text())
          .then((result) => {
            var resul = JSON.parse(result);
            if (resul.suggestions.length > 0) {
              var cadastreNum;

              if (resul.suggestions[0].data.flat_cadnum != null) {
                cadastreNum = resul.suggestions[0].data.flat_cadnum;
              } else if (resul.suggestions[0].data.house_cadnum != null) {
                cadastreNum = resul.suggestions[0].data.house_cadnum;
              } else {
                cadastreNum = resul.suggestions[0].data.stead_cadnum;
              }

              this.regAddressData = {
                addressType: "802740000",
                index: resul.suggestions[0].data.postal_code,
                region: resul.suggestions[0].data.region_fias_id,
                area: resul.suggestions[0].data.area_fias_id,
                city: resul.suggestions[0].data.city_fias_id,
                settlement: resul.suggestions[0].data.settlement_fias_id,
                street: resul.suggestions[0].data.street_fias_id,
                house: resul.suggestions[0].data.house_fias_id,
                flat: resul.suggestions[0].data.flat,
                cadastr: cadastreNum,
              };
            }
          })
          .catch((error) => console.log("error", error));
      }
    },

    setRegistrationsAddress(payload) {
      this.registrationsAddress = payload;
    },
  },
  created() {
    let keys = Object.keys(this.income);
    keys.forEach((key) => {
      this[key] = this.income[key];
    });
  },
  watch: {
    dataIsValid: {
      immediate: true,
      handler: function (value) {
        this.$emit("lockFwdBtn", !value || !this.regAddressData);
      },
    },
    regAddress: {
      immediate: true,
      handler: function (value) {
        this.addressErrorText =
          this.regAddressData || this.openFirst ? "" : this.errorText;
        this.$emit("lockFwdBtn", !this.dataIsValid || !this.regAddressData);
      },
    },

    regAddressData: {
      immediate: true,
      handler: function (value) {
        this.addressErrorText =
          this.regAddressData || this.openFirst ? "" : this.errorText;
        this.openFirst = false;
        this.$emit("lockFwdBtn", !this.dataIsValid || !this.regAddressData);
      },
    },
    searcher(value) {
      if (value) {
        this.regAddress = value;
        this.regAddressData = null;

        var findResult = this.res.find(
          (x) => x.value.toLowerCase() == this.regAddress.toLowerCase()
        );
        if (findResult != null) {
          var cadastreNum;

          if (findResult.data.flat_cadnum != null) {
            cadastreNum = findResult.data.flat_cadnum;
          } else if (findResult.data.house_cadnum != null) {
            cadastreNum = findResult.data.house_cadnum;
          } else {
            cadastreNum = findResult.data.stead_cadnum;
          }

          this.regAddressData = {
            addressType: "802740000",
            index: findResult.data.postal_code,
            region: findResult.data.region_fias_id,
            area: findResult.data.area_fias_id,
            city: findResult.data.city_fias_id,
            settlement: findResult.data.settlement_fias_id,
            street: findResult.data.street_fias_id,
            house: findResult.data.house_fias_id,
            flat: findResult.data.flat,
            cadastr: cadastreNum,
          };
        }
      }
      if (this.dataRequestCount > 1) {
        this.changeAddress(value);
        this.dataRequestCount = 1;
      } else {
        this.dataRequestCount += 1;
      }
    },
  },
  mounted() {
    if (this.document) {
      this.series = this.document.series;
      this.issuer = this.document.issuer;
      this.number = this.document.number;
      this.issueDate = this.document.issueDate;
      this.unitCode = this.document.unitCode;
      this.birthDate = this.document.birthDate;
      this.birthPlace = this.document.birthPlace;
      this.dataIsValid = this.document.dataIsValid;
      (this.inn = this.document.inn),
        (this.snils = this.document.snils),
        (this.phone = this.document.phone);
    }

    if (this.formData.regAddress) {
      this.regAddress = this.formData.regAddress;
      if (this.regAddress.value != null) {
        this.moutedAddress(this.regAddress.value);
      } else {
        this.moutedAddress(this.regAddress);
      }
    } else if (this.regAddress) {
      this.moutedAddress(this.regAddress);
    }

    if (this.formData.objectLocateType) {
      this.objectLocateType = this.formData.objectLocateType;
    }
  },
};
</script>
